import type { RecommendationCardTitleProps } from "./recommendation-card-title.type";

import RecommendationRename from "@/modules/recommendation/recommendation-rename";

const RecommendationCardTitle = ({
  interventionId,
  observation,
  loading = false,
  disabled,
  hover,
}: RecommendationCardTitleProps) => {
  const recommendation = observation?.recommendation;
  if (!recommendation) {
    return null;
  }

  const isEditable = hover && !disabled && !loading ? true : false;
  return (
    <RecommendationRename
      recommendation={recommendation}
      interventionId={interventionId}
      isEditable={isEditable}
      isLoading={loading}
    />
  );
};

export default RecommendationCardTitle;
